import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {SettlementStatus} from '@app/models/costs';

@Component({
  selector: 'app-settlement-status',
  template: `
    <span class="settlement-badge"
          [ngClass]="getBadgeClass()">
      {{ getDisplayText() }}
    </span>
  `,
  styles: [`
    .settlement-badge {
      padding: 0.25rem 0.5rem;
      border-radius: 4px;
      font-size: 0.875rem;
      font-weight: 500;
    }

    .initial {
      background-color: #f0f0f0;
      color: #666666;
    }

    .pending {
      background-color: #feedaf;
      color: #8a5340;
    }

    .transferred {
      background-color: #c8e6c9;
      color: #256029;
    }

    .refund-pending {
      background-color: #ffcdd2;
      color: #c63737;
    }

    .refund-completed {
      background-color: #b3e5fc;
      color: #23547b;
    }

    .refund-refused {
      background-color: #e1bee7;
      color: #6a1b9a;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettlementStatusComponent implements OnInit {
  @Input() status: SettlementStatus = SettlementStatus.INITIAL;

  constructor() {
  }

  ngOnInit(): void {
  }

  getBadgeClass(): string {
    switch (this.status) {
      case SettlementStatus.INITIAL:
        return 'initial';
      case SettlementStatus.PENDING:
        return 'pending';
      case SettlementStatus.TRANSFERRED:
        return 'transferred';
      case SettlementStatus.REFUND_PENDING:
        return 'refund-pending';
      case SettlementStatus.REFUND_COMPLETED:
        return 'refund-completed';
      case SettlementStatus.REFUND_REFUSED:
        return 'refund-refused';
      default:
        return 'initial';
    }
  }

  getDisplayText(): string {
    switch (this.status) {
      case SettlementStatus.INITIAL:
        return 'เริ่มต้น';
      case SettlementStatus.PENDING:
        return 'รอโอน';
      case SettlementStatus.TRANSFERRED:
        return 'โอนแล้ว';
      case SettlementStatus.REFUND_PENDING:
        return 'รอคืนเงิน';
      case SettlementStatus.REFUND_COMPLETED:
        return 'คืนเงินแล้ว';
      case SettlementStatus.REFUND_REFUSED:
        return 'ไม่คืนเงิน';
      default:
        return 'ไม่ระบุ';
    }
  }
}
